// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from '../../common/components/core';

type Props = {};

class ScreenLinkExpired extends React.Component<Props> {
  render() {
    return (
      <div className="link-exipred-background">
        <div className="link-expired">
          <div className="expired-logo">
            <img src="/static/images/branch-logos/branch-logo_dark.svg" />
          </div>
          <div className="loggedout-link-expired-container">
            <div className="loggedout--link-expired-header">
              Link has expired!
            </div>
            <img
              className="link-expired-image"
              src="/static/images/link_expired.svg"
            />
            <div className="loggedout--link-expired-text-block">
              This link has expired, please reset password again.
            </div>
            <Link
              to="/reset"
              i13nModel={{ label: 'Send reset email link' }}
              testid="link-send-reset-email"
              className="link-expired-btn"
            >
              Reset Password
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

ScreenLinkExpired.contextTypes = {
  router: PropTypes.object
};

export default ScreenLinkExpired;
